const isArrayValid = <T>(array: Array<T> | null | undefined) => Array.isArray(array) && !!array.length;
export default isArrayValid;
